import * as React from 'react';
import { makeFileRequest, addScriptsToDocument, getHeaderKey } from './helpers.js';
import { REACT_COMP_VERSION } from '../constants.js';

var _a;
var headerContainer = typeof document !== "undefined"
    ? document.getElementById("bookendsHeader")
    : null;
var headerAddedOnEdge = headerContainer && ((_a = headerContainer === null || headerContainer === void 0 ? void 0 : headerContainer.children) === null || _a === void 0 ? void 0 : _a.length) > 0;
var header = headerAddedOnEdge && headerContainer ? headerContainer.innerHTML : "";
var headerScripts;
var isSpaEntry = true;
var Header = function (props) {
    var _a = React.useState(false), isHeaderAdded = _a[0], setIsHeaderAdded = _a[1];
    var _b = React.useState(header), headerHtml = _b[0], setHeaderHtml = _b[1];
    var _c = React.useState(headerScripts), bookendsScripts = _c[0], setBookendsScripts = _c[1];
    var variation = 'default';
    if (typeof window !== "undefined") {
        window.bookends.SearchBarConfig = props.searchBarProps;
        window.bookends.trackingConfiguration = props.trackingConfiguration;
        window.bookends.useMiniCart = props.useMiniCart === undefined ? true : props.useMiniCart;
        window.bookends.MiniCartConfig = props.MiniCartConfig;
        if (window.bookendsHeaderVariation) {
            variation = window.bookendsHeaderVariation;
        }
    }
    React.useEffect(function () {
        if ((headerAddedOnEdge || isHeaderAdded) && headerContainer) {
            var scripts = Array.from(headerContainer === null || headerContainer === void 0 ? void 0 : headerContainer.querySelectorAll("script")).map(function (script) {
                return {
                    src: script.src,
                    innerHTML: script.innerHTML.trim()
                };
            });
            headerScripts = scripts;
            if (!isHeaderAdded) {
                setIsHeaderAdded(true);
            }
        }
    }, []);
    React.useEffect(function () {
        if ((!header && (headerContainer === null || headerContainer === void 0 ? void 0 : headerContainer.children.length) === 0) || (!headerContainer && isSpaEntry)) {
            var bundleScriptHtmlPromise = makeFileRequest(props.stagingContent, "/html/statics/dep-share/".concat(REACT_COMP_VERSION, "_bundle-script.html"));
            var headerHtmlPromise = makeFileRequest(props.stagingContent, "/esi/".concat(REACT_COMP_VERSION, "/").concat(props.tenant, "/").concat(props.locale.toLowerCase(), "/header/").concat(props.type, "/hidesearch-").concat(props.hideSearch || false, "_hidevat-").concat(props.hideVat || false, "/dep-share/").concat(variation, "-fullcomponent.html"));
            var parser_1 = new DOMParser();
            Promise.all([bundleScriptHtmlPromise, headerHtmlPromise]).then(function (htmlResponse) {
                var tmpElement = parser_1.parseFromString(htmlResponse[1], "text/html");
                var scriptElements = Array.from(tmpElement.querySelectorAll("script"));
                var scripts = [{
                        src: undefined,
                        innerHTML: htmlResponse[0].replace("<script>", "").replace("</script>", "").trim()
                    }];
                scriptElements.forEach(function (scriptElement) {
                    scripts.push({
                        src: scriptElement.src,
                        innerHTML: scriptElement.innerHTML.trim()
                    });
                    tmpElement.body.removeChild(scriptElement);
                });
                setHeaderHtml(tmpElement.head.outerHTML + tmpElement.body.outerHTML);
                setBookendsScripts(scripts);
                isSpaEntry = false;
                header = tmpElement.head.outerHTML + tmpElement.body.outerHTML;
                headerScripts = scripts;
            });
        }
    }, []);
    React.useEffect(function () {
        var _a;
        var headerElement = document.getElementById("".concat(props.type, "_header"));
        if (((!headerAddedOnEdge && !isHeaderAdded) || !isSpaEntry)
            && bookendsScripts
            && ((_a = headerElement === null || headerElement === void 0 ? void 0 : headerElement.dataset) === null || _a === void 0 ? void 0 : _a.hydrated) !== "true") {
            if (!window.bundleInterval
                || !window["".concat(props.type, "_header_componentWrapperInterval")]) {
                var scriptsToAdd = bookendsScripts;
                if (window.bundleInterval) { //Prevent double loading bundleInterval
                    scriptsToAdd = bookendsScripts.filter(function (script) { return !script.innerHTML.startsWith("var bundleInterval"); });
                }
                addScriptsToDocument(scriptsToAdd);
            }
            if (window
                && window.ComponentWrapper
                && window.ComponentWrapper["show_".concat(props.type, "_header")]
                && window["".concat(props.type, "_header_props")]) {
                window.ComponentWrapper["show_".concat(props.type, "_header")](window["".concat(props.type, "_header_props")]);
            }
        }
    });
    return (React.createElement("div", { id: "bookendsHeader", "data-headerkey": getHeaderKey(props.tenant, props.locale, props.type, props.hideSearch, props.hideVat, props.showStickyHeader), dangerouslySetInnerHTML: { __html: headerHtml } }));
};

export { Header };
//# sourceMappingURL=Header.js.map
